// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardHome {
  height: 400px;
  position: relative;
  overflow: hidden;
  border: 0px;
  border-radius: 15px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.cardHome div {
  display: flex;
  align-items: center;
}
.cardHome h2 {
  font-size: 24px;
  padding: 20px;
  font-family: "Nunito Sans", sans-serif;
  font-style: normal;
  font-weight: 900;
  color: rgb(17, 47, 72);
  text-align: center;
  margin-bottom: 0px;
}
.card1 .row .col-lg-3:last-child .cardHome {
  overflow: visible;
}
.card1 .row .col-lg-3:first-child img {
  position: absolute;
  bottom: 0px;
  width: 100%;
}

.card1 .row .col-lg-3:nth-child(2) img {
  position: absolute;
  bottom: 0px;
}
.card1 .row .col-lg-3:nth-child(3) img {
  position: absolute;
  bottom: 0px;
}
.card1 .row .col-lg-3:nth-child(4) img {
  position: absolute;
  bottom: 0px;
  width: 95%;
}

@media (max-width: 1024px) {
  .cardHome {
    height: 265px !important;
  }

  .cardHome h2 {
    font-size: 20px;
    padding: 15px 5px;
  }
}

@media (max-width: 576px) {
  .card1 .row .col-lg-3:nth-child(2) img,
  .card1 .row .col-lg-3:first-child img,
  .card1 .row .col-lg-3:nth-child(3) img,
  .card1 .row .col-lg-3:nth-child(4) img {
    position: static;
  }
  .card1 .row .col-lg-3 img {
    /* display: none; */
  }
  .cardHome h2 {
    margin-top: 0px;
    text-align: right;
    font-size: 14px;
    line-height: 1.3;
    text-align: center;
    padding: 15px 10px;
    margin-bottom: 0px;
  }
  .banner_txt {
    padding: 0px 10px;
  }
  .heighlight-2 .cardHome h2 {
    padding: 10px;
    margin-bottom: 0px;
  }

  .cardHome {
    height: 180px !important;
    position: relative;
    overflow: hidden;
    /* padding: 10px; */
  }
  .card1 .row .col-lg-3:first-child img {
    width: 100%;
    margin-left: 0px;
  }
  .card1 .row .col-lg-3:nth-child(4) {
    display: none;
  }
  .heighlight-2 .cardHome {
    margin-top: 20px;
  }

  .cardHome h2,
  .heighlight-2 .cardHome h2 {
    font-size: 14px;
  }

  .custm-ptb h2 {
    padding: 15px 25px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/card.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,4EAA4E;AAC9E;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".cardHome {\r\n  height: 400px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border: 0px;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n.cardHome div {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.cardHome h2 {\r\n  font-size: 24px;\r\n  padding: 20px;\r\n  font-family: \"Nunito Sans\", sans-serif;\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  color: rgb(17, 47, 72);\r\n  text-align: center;\r\n  margin-bottom: 0px;\r\n}\r\n.card1 .row .col-lg-3:last-child .cardHome {\r\n  overflow: visible;\r\n}\r\n.card1 .row .col-lg-3:first-child img {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  width: 100%;\r\n}\r\n\r\n.card1 .row .col-lg-3:nth-child(2) img {\r\n  position: absolute;\r\n  bottom: 0px;\r\n}\r\n.card1 .row .col-lg-3:nth-child(3) img {\r\n  position: absolute;\r\n  bottom: 0px;\r\n}\r\n.card1 .row .col-lg-3:nth-child(4) img {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  width: 95%;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .cardHome {\r\n    height: 265px !important;\r\n  }\r\n\r\n  .cardHome h2 {\r\n    font-size: 20px;\r\n    padding: 15px 5px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .card1 .row .col-lg-3:nth-child(2) img,\r\n  .card1 .row .col-lg-3:first-child img,\r\n  .card1 .row .col-lg-3:nth-child(3) img,\r\n  .card1 .row .col-lg-3:nth-child(4) img {\r\n    position: static;\r\n  }\r\n  .card1 .row .col-lg-3 img {\r\n    /* display: none; */\r\n  }\r\n  .cardHome h2 {\r\n    margin-top: 0px;\r\n    text-align: right;\r\n    font-size: 14px;\r\n    line-height: 1.3;\r\n    text-align: center;\r\n    padding: 15px 10px;\r\n    margin-bottom: 0px;\r\n  }\r\n  .banner_txt {\r\n    padding: 0px 10px;\r\n  }\r\n  .heighlight-2 .cardHome h2 {\r\n    padding: 10px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .cardHome {\r\n    height: 180px !important;\r\n    position: relative;\r\n    overflow: hidden;\r\n    /* padding: 10px; */\r\n  }\r\n  .card1 .row .col-lg-3:first-child img {\r\n    width: 100%;\r\n    margin-left: 0px;\r\n  }\r\n  .card1 .row .col-lg-3:nth-child(4) {\r\n    display: none;\r\n  }\r\n  .heighlight-2 .cardHome {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .cardHome h2,\r\n  .heighlight-2 .cardHome h2 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .custm-ptb h2 {\r\n    padding: 15px 25px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
